"use client";

import AivelLogo from "./project_components/specific/aivel_logo";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useLogout } from "./service/logoutQuery";
import { useUserStore } from "@/lib/store/userStore";
import { InstantLoadingButton } from "./project_components/general/InstantPageButton";

const Navigation = () => {
  const router = useRouter();
  const userProfile = useUserStore((s) => s.profile);

  const { logout } = useLogout();

  const handleMain = () => {
    router.push("/");
  };

  return (
    <div className="flex flex-row px-4 sm:px-2 py-2 z-50 justify-between rounded-2xl items-center bg-transparent/5 backdrop-blur-lg">
      <div
        className="flex gap-x-2 items-center justify-center cursor-pointer"
        onClick={handleMain}
      >
        <AivelLogo
          svgClass="h-4 w-4"
          rectFillClass="fill-blue-50"
          strokeThin="stroke-blue-800 stroke-[24px]"
          strokeThick="stroke-gray-800 stroke-[48px]"
        />
        <p className="font-extrabold text-xl">AIVEL</p>
      </div>

      <div className="gap-4 items-center hidden md:flex font-bold">
        {userProfile ? (
          // 로그인된 상태
          <>
            {/* <Link className="btn-main" href="/dashboard">
              워크스페이스
            </Link> */}
            <InstantLoadingButton className="btn-main" href="/dashboard">
              대시보드 이동
            </InstantLoadingButton>
            |
            <button className="btn-main" onClick={logout}>
              로그아웃
            </button>
          </>
        ) : (
          // 로그인하지 않은 상태
          <>
            <Link className="btn-main" href="/login">
              Get Started &rarr;
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default Navigation;
